<template>
  <div class="sphereViewer-flex-relative" v-if="myshow == 'true'" id="imgbody">
    <audio :src="audiosrc" autoplay="autoplay"></audio>
    <div class="sphereViewer-flex" v-if="imgList.length != 0">
      <van-swipe class="my-swipe" @change="onChange" :loop="false" :show-indicators="false" :initial-swipe="current_load">
        <van-swipe-item v-for="(item, index) in imgList" :key="index" class="my-swipe">
          <div class="my-swipe-item"><img :src="item.image_text" v-if="item.clientWidth != undefined" :style="{ width: item.clientWidth + 'px' }" /></div>

          <div class="pswp_footer" >
            <div id="show" @click="hrefTap(item.weblink)" v-if="item.weblink.length > 8">
              <div>720度全景展示</div>
              <img src="../../assets/img/tip.gif" v-if="item.is_frame != 1" />
            </div>
            <div id="show" @click="assemblingTap(item.pic_id)" v-if="item.is_frame == 1"><div>装配</div><img src="../../assets/img/tip.gif" /></div>
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator-flex">
            <div class="custom-indicator">{{ current + 1 }}/{{ imgList.length }}</div>
            <div class="custom-indicator-text">{{ goodsobject.list[current].title }}</div>
            <div class="custom-indicator-button iconfont icon-002" @click="mayshowTap()"></div>
          </div>
        </template>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  props: {
    value: {
      type: String,
    },
    goodsobject: {
      type: Object,
    },
  },
  data() {
    return {
      imgList: [],
      current: 0,
      myshow: this.value,
      current_load: 0,
      title: '',
      audiosrc: '',
    };
  },
  watch: {
    value(newVal) {
      this.myshow = newVal;
      const { clientWidth, clientHeight } = document.body;
      const img = this.goodsobject.list[this.goodsobject.index];
      if (img.width > img.height || clientHeight - 90 > img.height * (clientWidth / img.width)) {
        this.goodsobject.list[this.goodsobject.index].clientWidth = clientWidth;
      } else {
        this.goodsobject.list[this.goodsobject.index].clientWidth = img.width * ((clientHeight - 90) / img.height); // clientWidth * (img.width / img.height);
      }
      this.imgList = this.goodsobject.list;
      if (this.current == 0) {
        this.current = this.goodsobject.index;
        this.current_load = this.goodsobject.index;
      }
    },
    goodsobject(newVal) {
      this.imgList = this.goodsobject.list;
      this.current_load = this.current;
    },
    myshow(newVal) {
      this.$emit('input', newVal);
      this.$api.commit('myshow', this.myshow == 'true');
    },
  },
  methods: {
    hrefTap(item) {
      window.location.href = item;
    },
    assemblingTap(pic_id) {
      this.$router.push({
        path: `/assembling?pic_id=${pic_id}`,
      });
    },
    onChange(event) {
      console.log(event, this.imgList.length);
      this.current = event;
      this.audiosrc = 'https://book.yunzhan365.com/resourceFiles/html5_templates/template/Metro/style/raw/flipsound.ogg?2018071601';
      setTimeout(() => {
        this.audiosrc = '';
      }, 1000);
      const { clientWidth, clientHeight } = document.body;
      const img = this.imgList[this.current];
      if (img.width > img.height || clientHeight - 90 > img.height * (clientWidth / img.width)) {
        this.imgList[this.current].clientWidth = clientWidth;
      } else {
        this.imgList[this.current].clientWidth = img.width * ((clientHeight - 90) / img.height); // clientWidth * (img.width / img.height);
      }
      if (event + 1 == this.imgList.length) {
        this.$emit('scroll');
      }
    },
    mayshowTap() {
      this.myshow = 'false';
    },
  },
};
</script>

<style lang="less">
.sphereViewer-flex-relative {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  .pswp_footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 55px;
    display: flex;
    z-index: 9999;
    flex-wrap: nowrap;
  }
  .pswp_footer #show {
    flex: 1;
    height: 55px;
    text-align: center;
    line-height: 55px;
    color: white;
    background-color: #111;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
  }

  .pswp_footer #show img {
    width: 50px;
    position: absolute;
    left: 50%;
    margin-left: -25px;
    top: 20%;
  }

  .sphereViewer-flex {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    position: relative;
    background-color: #000000;

    .my-swipe {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .my-swipe-item {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .custom-indicator-flex {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      display: flex;
      justify-content: space-between;
      top: 0;
      flex-wrap: nowrap;
      z-index: 1200;
      align-items: center;
    }

    .custom-indicator-button {
      color: #fff;
      font-size: 14px;
      padding: 0 10px;
    }

    .custom-indicator-text {
      color: #fff;
      font-size: 14px;
      top: 12px;
    }

    .custom-indicator {
      height: 44px;
      font-size: 13px;
      line-height: 44px;
      color: #fff;
      opacity: 0.75;
      padding: 0 10px;
    }
  }
}
</style>
